import React, { useEffect, useState } from "react";
import { Button, Layout, Space, Table, Tag, Typography, Alert, Row, Input, Collapse, Form, Modal, DatePicker, Card } from 'antd';
import { EyeOutlined, FilterOutlined, CaretLeftOutlined, CaretRightOutlined, UsergroupAddOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { cloneDeep } from "lodash";
import moment from "moment-timezone";
import "./style.scss";
import Swal from "sweetalert2";

const { Content } = Layout;
const { Title, Text } = Typography;
const { Search } = Input;
const { Panel } = Collapse;

const Events = ({ userStore, eventStore }) => {

  const [form] = Form.useForm();
  const navigate = useNavigate()

  const [isEditEvent, setIsEditEvent] = useState(false);
  const [editableEvent, setEditableEvent] = useState();

  useEffect(() => {
    
    eventStore.page = 1;
    eventStore.hasMore = false;
    eventStore.perPage = 10;
    eventStore.fetchEventsByTeamLeader();

  }, []);

  const handlePrevPage = () => {
    eventStore.page = eventStore.page - 1;
    eventStore.fetchEventsByTeamLeader();
  };

  const handleNextPage = () => {
    eventStore.page = eventStore.page + 1;
    eventStore.fetchEventsByTeamLeader();
  };

  const columns = [
    {
      title: 'Event Name',
      key: 'EventName+EventID',
      dataIndex: 'EventName',
      render: (EventName) => (
        <Text default>{EventName}</Text>
      )
    },
    {
      title: 'Location',
      key: 'Location+EventID',
      dataIndex: 'Location',
      render: (Location) => (
        <Text default>{Location}</Text>
      )
    },
    {
      title: 'Date',
      key: 'Date+EventID',
      dataIndex: 'Date',
      render: (Date, record) => {
        return <Text>{moment(Date).format("MMM DD, YYYY")}</Text>;
      }
    },
    {
      title: 'Created By',
      dataIndex: 'CreatedBy',
      key: 'CreatedBy+EventID',
      render: (CreatedBy) => (
        <Text default>{CreatedBy}</Text>
      )
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => (
        <Space size={'small'}>
          <Link to={'/events/'+record.EventID}><Button icon={<EyeOutlined/>} type="primary" ghost>View</Button></Link>
          {/* <Button icon={<EditOutlined />} type="primary" ghost onClick={() => {
            setEditableEvent(record);
            form.setFieldsValue({
              EventName: record.EventName,
              Location: record.Location,
              Remarks: record.Remarks
            });
            setIsEditEvent(true);
          }}>Edit</Button> */}
        </Space>
      )
    },
  ];

  const handleUpdateEvent = (values) => {

    const datapost = {
      eventName : values.EventName,
      date: values.Date == null ? editableEvent.Date : values.Date,
      location: values.Location,
      remarks: values.Remarks
    }

    eventStore.updateEvent(datapost, editableEvent.EventID).then(() => {
      setIsEditEvent(false);
      eventStore.fetchEventsByTeamLeader(); // Refresh the list
    });

  };

  return (
    <div className="teamleader-list-events">
      <Content>
        <div className="teamleader-list-events-content">
          <Row justify={"space-between"} align={"middle"}>
            <Title level={4}>Events List</Title>
          </Row>
          <Alert
            message="List of Events"
            description="List of your registered voters. If you think there's a problem with the list of users, please contact an administrator for assistance."
            type="info"
            showIcon
          />
          <div className="mobile-data">
            {(cloneDeep(eventStore.events) ?? []).map((event) => (
              <Card
                className="card-data"
                actions={[
                  <Link className="link" to={'/events/'+event.EventID}><Button icon={<EyeOutlined/>} type="primary" ghost block>View</Button></Link>
                ]}
              >
                <Space direction="vertical">
                  <Text className="name-text" strong>{event.EventName}</Text>
                  <Tag color="blue"><Text strong>{event.CreatedBy}</Text></Tag>
                  <Text type="secondary" strong>{event.Location}</Text>
                  <Text strong italic>{moment(event.Date).format("MMM DD, YYYY")}</Text>
                </Space>
              </Card>
              ))
            }
          </div>
          <div className="web-data">
            <Table pagination={false} columns={columns} dataSource={cloneDeep(eventStore.events)} bordered/>
          </div>
          <ul className="pagination">
            <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={eventStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
            <li className="pagination-item"><a>{eventStore.page}</a></li>
            <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={eventStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
          </ul>
        </div>
        <Modal 
          title="Edit Details" 
          open={isEditEvent} 
          onCancel={() => setIsEditEvent(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsEditEvent(false)}>Cancel</Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>Save Changes</Button>
          ]}
        >
          <Form
            name="editTeamLeaderData"
            layout="vertical"
            form={form} 
            onFinish={(values) => {
              const formattedValues = {
                ...values,
                Date: values.Date ? values.Date.format("YYYY-MM-DD") : null, // Convert Date to YYYY-MM-DD
              };
              handleUpdateEvent(formattedValues);
            }}
          >
            <Form.Item label="Name" name="EventName" rules={[{ required: true, message: "Event Name is required" }]}>
              <Input placeholder="Enter Name" />
            </Form.Item>
            <Form.Item label="Address" name="Location" rules={[{ required: true, message: "Location is required" }]}>
              <Input placeholder="Enter Address" />
            </Form.Item>
            <Form.Item label="Remarks" name="Remarks" rules={[{ required: true, message: "Remarks is required" }]}>
              <Input.TextArea placeholder="Enter Remarks" />
            </Form.Item>
            <Form.Item
              label="Event Date"
              name="Date"
            >
              <DatePicker 
                format="YYYY-MM-DD" 
              />
            </Form.Item>
            <Alert
              description="You can leave the Date field empty if you don’t want to update the event date."
              type="info"
              showIcon
            />
          </Form>
        </Modal>
      </Content>
    </div>

  );
};

export default inject('userStore', 'eventStore')(observer(Events));
